import { PerceivedProvisioningStartTimer } from "../../utils/perceived-provisioning/perceived-provisioning-start-timer";
import { defaultScreenConfig } from "../../utils/screen-manager/default-screen-config";
import { teamChoiceDictionaryItem } from "../../utils/screen-manager/default-screen-dictionary";
import { PROVISIONING } from "../../utils/screen-manager/utils";
import { ProductRedirector } from "../product-redirector/product-redirector";
import ServiceCollectionProvisioningScreen from "../service-collection-provisioning-screen/service-collection-provisioning-screen";

import { BaseProvisioningUI } from "./base-provisioning-ui";

const serviceCollectionScreenDictionary = {
    ...teamChoiceDictionaryItem,
    [PROVISIONING]: (
        <PerceivedProvisioningStartTimer>
            <ProductRedirector>
                <ServiceCollectionProvisioningScreen />
            </ProductRedirector>
        </PerceivedProvisioningStartTimer>
    )
};

/**
 * Component that shows Service Collection provisioning UI with team choice support.
 * @returns @type {JSX.Element}
 */
export const ServiceCollectionProvisioningUI = () => {
    return (
        <BaseProvisioningUI
            screenConfig={defaultScreenConfig}
            screenDictionary={serviceCollectionScreenDictionary}
            screenFallback={
                <PerceivedProvisioningStartTimer>
                    <ProductRedirector>
                        <ServiceCollectionProvisioningScreen />
                    </ProductRedirector>
                </PerceivedProvisioningStartTimer>
            }
        />
    );
};
